import Joi from "joi";

export type PersonaVerificationDto = {
  status: string;
};
export const personaVerificationDtoSchema = Joi.object({
  status: Joi.string().required(),
}).unknown();
